const commonHeaderLinkLists = (t) => {
  return [
    {
      title: t("Webhook Config"),
      link: "/admin/webhook/list",
    },
    {
      title: t("Webhook Data"),
      link: "/admin/webhook/data",
    },
  ];
};

export { commonHeaderLinkLists };
